import styled from 'styled-components'
import Row from './Row'

export default styled(Row)`
  &&& {
    align-items: start;
  }
`
